<!--
 * @Descripttion: 饼图配置
 * @Author: zenghua.wang
 * @Date: 2021-08-30 10:20:47
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-13 11:27:15
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 接口设置 -->
    <api-interface
      :data="data"
      :apis="main.apiTableList"
    >
      <template v-slot:extend>
        <echart-field :data="data" />
        <echart-filter :data="data" />
      </template>
    </api-interface>

    <el-collapse-item title="饼图">
      <el-form-item label="横坐标(%)">
        <el-slider
          v-model="data.option.centerX"
          :min="0"
          :max="100"
        />
      </el-form-item>

      <el-form-item label="纵坐标(%)">
        <el-slider
          v-model="data.option.centerY"
          :min="0"
          :max="100"
        />
      </el-form-item>

      <el-form-item label="设置为环形">
        <el-switch
          v-model="data.option.radius"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item
        label="起始半径(%)"
        v-if="data.option.radius"
      >
        <el-slider
          v-model="data.option.startRadius"
          :min="0"
          :max="100"
        />
      </el-form-item>

      <el-form-item label="结束半径(%)">
        <el-slider
          v-model="data.option.endRadius"
          :min="0"
          :max="100"
        />
      </el-form-item>

      <!-- <el-form-item label="边框宽度">
        <el-slider
          v-model="data.option.borderWidth"
          :min="0"
          :max="100"
        />
      </el-form-item>

      <el-form-item label="边框圆角">
        <el-slider
          v-model="data.option.borderRadius"
          :min="0"
          :max="100"
        />
      </el-form-item>

      <el-form-item label="边框颜色">
        <el-color-picker
          v-model="data.option.borderColor"
          :predefine="predefineColors"
        ></el-color-picker>
      </el-form-item> -->

      <el-form-item label="南丁格尔玫瑰">
        <el-switch
          v-model="data.option.roseType"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="自动排序">
        <el-switch
          v-model="data.option.sort"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="不展示零">
        <el-switch
          v-model="data.option.notCount"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>
    </el-collapse-item>

    <el-collapse-item title="动态环图">
      <el-form-item label="开始">
        <el-switch
          v-model="data.option.animation"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <template v-if="data.option.animation">
        <el-form-item label="循环时间(ms)">
          <el-input-number
            v-model="data.option.animationTime"
            :min="1000"
          />
        </el-form-item>

        <el-form-item label="left位置(%)">
          <el-input-number
            v-model="data.option.activeLeft"
            :max="100"
          />
        </el-form-item>

        <el-form-item label="top位置(%)">
          <el-input-number
            v-model="data.option.activeTop"
            :max="100"
          />
        </el-form-item>

        <el-form-item label="名称字体大小">
          <el-input-number v-model="data.option.activeTitleFontSize" />
        </el-form-item>

        <el-form-item label="名称字体颜色">
          <el-color-picker
            v-model="data.option.activeTitleColor"
            :predefine="predefineColors"
          ></el-color-picker>
        </el-form-item>

        <el-form-item label="数值字体大小">
          <el-input-number v-model="data.option.activeValueFontSize" />
        </el-form-item>

        <el-form-item label="数值字体颜色">
          <el-color-picker
            v-model="data.option.activeValueColor"
            :predefine="predefineColors"
          ></el-color-picker>
        </el-form-item>
      </template>
    </el-collapse-item>

    <!-- echart公共 -->
    <echart-common :data="data" />
  </el-collapse>
</template>
<script>
import configBase from '@/dragComponents/config/common/base.vue'
import apiInterface from '@/dragComponents/config/api/index.vue'
import echartField from '@/dragComponents/config/common/field.vue'
import echartFilter from '@/dragComponents/config/common/filter.vue'

import echartCommon from './common.vue'

import {
  predefineColors,
  component,
  theme
} from '@/dragComponents/model/default.js'
export default {
  name: 'config-echart-pie',
  components: {
    configBase,
    echartCommon,
    echartField,
    echartFilter,
    apiInterface
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component
    }
  },
  methods: {}
}
</script>
